module.exports = __webpack_public_path__ + "img/SINGLE EAR RING BN.e6b235a.svg";